import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import { useMyFolders } from './context/MyFolders';

import MyFoldersHeader from './components/MyFoldersHeader';
import MyFoldersBody from './components/MyFoldersBody';

import './MyFolders.scss';

const MyFolders: FC = () => {
  const { data } = useMyFolders();

  return (
    <>
      <MyFoldersHeader />
      <MyFoldersBody />
      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default MyFolders;
